module.exports = __webpack_public_path__ + "img/RepGuideLogo.caa0e772.svg";